/**
 * Divider atom — horizontal or vertical separator. Accessible (aria-hidden).
 */

import React from "react";
import { cn } from "@/utils/cn";
import type { DividerProps } from "./Divider.types";

export const Divider: React.FC<DividerProps> = ({
  orientation = "horizontal",
  className,
}) => {
  return (
    <hr
      className={cn(
        "border-gray-200",
        orientation === "horizontal" ? "w-full border-t" : "h-full border-l self-stretch",
        className
      )}
      aria-hidden
    />
  );
};
